module.exports = __webpack_public_path__ + "static/img/headImage.bf33c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/headImage.png
// module id = hBix
// module chunks = 170